import { render } from "./ScheduledDoseTimesModal.vue?vue&type=template&id=bc544fa2"
import script from "./ScheduledDoseTimesModal.vue?vue&type=script&lang=js"
export * from "./ScheduledDoseTimesModal.vue?vue&type=script&lang=js"

import "./ScheduledDoseTimesModal.vue?vue&type=style&index=0&id=bc544fa2&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__